export default __webpack_public_path__ + "static/1618-6a4eb714459afbb90395ea18176440ac.gif";